var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1305_8077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.185 23.655V23.7068C30.185 29.8108 25.2412 34.7546 19.1445 34.7546H18.3095C18.073 34.7546 17.8587 34.8877 17.7479 35.0946L16.6615 37.1046C16.4177 37.5554 15.7748 37.5554 15.5309 37.1046L14.4446 35.0946C14.3337 34.8877 14.112 34.7546 13.8829 34.7546H13.0996C6.96601 34.7473 2 29.7812 2 23.655C2 17.5288 6.96601 12.5628 13.0922 12.5628H19.0928C25.219 12.5628 30.185 17.5288 30.185 23.655Z",
    fill: "#FF8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8149 33.3579V33.4096C23.8149 39.5137 28.7588 44.4575 34.8554 44.4575H35.6905C35.927 44.4575 36.1413 44.5905 36.2521 44.7975L37.3384 46.8075C37.5823 47.2583 38.2252 47.2583 38.4691 46.8075L39.5554 44.7975C39.6663 44.5905 39.888 44.4575 40.117 44.4575H40.9004C47.0266 44.4575 52 39.4915 52 33.3579C52 27.2317 47.034 22.2657 40.9078 22.2657H34.9072C28.7809 22.2657 23.8149 27.2317 23.8149 33.3579Z",
    fill: "#84BDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9521 13.9521V14.0038C40.9521 20.1079 36.0083 25.0517 29.9116 25.0517H29.0766C28.8401 25.0517 28.6258 25.1847 28.5149 25.3916L27.4286 27.4017C27.1848 27.8525 26.5418 27.8525 26.298 27.4017L25.2117 25.3916C25.1008 25.1847 24.8791 25.0517 24.65 25.0517H23.8667C17.7405 25.0517 12.7671 20.0857 12.7671 13.9521C12.7671 7.82587 17.7331 2.85986 23.8593 2.85986H29.8599C35.9861 2.85986 40.9521 7.82587 40.9521 13.9521Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4873 15.6517C22.2179 15.6517 22.8101 15.0595 22.8101 14.329C22.8101 13.5984 22.2179 13.0062 21.4873 13.0062C20.7568 13.0062 20.1646 13.5984 20.1646 14.329C20.1646 15.0595 20.7568 15.6517 21.4873 15.6517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8594 15.6517C27.59 15.6517 28.1822 15.0595 28.1822 14.329C28.1822 13.5984 27.59 13.0062 26.8594 13.0062C26.1289 13.0062 25.5366 13.5984 25.5366 14.329C25.5366 15.0595 26.1289 15.6517 26.8594 15.6517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2246 15.6517C32.9552 15.6517 33.5474 15.0595 33.5474 14.329C33.5474 13.5984 32.9552 13.0062 32.2246 13.0062C31.4941 13.0062 30.9019 13.5984 30.9019 14.329C30.9019 15.0595 31.4941 15.6517 32.2246 15.6517Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1305_8077",
    x: 0,
    y: 0.859863,
    width: 54,
    height: 48.2857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1305_8077"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1305_8077",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryChat);
export default __webpack_public_path__ + "static/media/category_chat.47200167c95ff628abafda57b24fb3f1.svg";
export { ForwardRef as ReactComponent };